const base = 8;
const horizontalFactor = 1;
const verticalFactor = 1.3;
export const Spacing = {
    horizontal: base * horizontalFactor,
    vertical: base * verticalFactor,
};
Object.freeze(Spacing);
